import MyApplications from "../../js/pages/student/MyApplications";
import MyTransport from "../../js/pages/student/MyTransport";
import ApplicantDashboard from "../../js/pages/student/dashboard";
import AdmissionForm from "../../js/pages/student/form";
import Main from "../../js/components/layout/Main";
import ProtectedRoute from "../components/comps/protected_route";

const ApplicantRoutes = [
  {
    path: "/applicant",
    element: <Main />,
    children: [
      {
        path: "dashboard",
        element: (
          <ProtectedRoute>
            <ApplicantDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "form",
        element: (
          <ProtectedRoute>
            <AdmissionForm />
          </ProtectedRoute>
        ),
      },
      {
        path: "my_application",
        element: (
          <ProtectedRoute>
            <MyApplications />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default ApplicantRoutes;
